import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import './App.scss';
import PresenceForwarder from './components/PresenceForwarder/PresenceForwarder';
import SlideContainer from './components/containers/SlideContainer';
import { loadStyles } from './ducks/customStylesReducer';
import { BreakpointSizes, WindowSizes } from './utils/constants';
import { useWindowDimensions } from './utils/functions';

const App = () => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const [windowSize, setWindowSize] = useState<WindowSizes>(WindowSizes.Small);

  useEffect(() => {
    dispatch(loadStyles());
  }, [dispatch]);

  useEffect(() => {
    if (width < BreakpointSizes.MediumBreakpoint) {
      setWindowSize(WindowSizes.Small);
    } else if (width < BreakpointSizes.LargeBreakpoint) {
      setWindowSize(WindowSizes.Medium);
    } else {
      setWindowSize(WindowSizes.Large);
    }
  }, [width]);

  return (
    <div className="App learning-output">
      <PresenceForwarder />
      <SlideContainer windowSize={windowSize} />
    </div>
  );
};

export default App;
